module.exports = __webpack_public_path__ + "img/event.5686b4f9.svg";